export const TeamEditPageSkeleton = () => {
  return (
    <div className="w-full p-8">
      <div className="flex items-center justify-between">
        <div className="h-8 w-44 animate-pulse rounded-md bg-skeleton" />
        <div className="flex items-center gap-6">
          <div className="h-10 w-32 animate-pulse rounded-md bg-skeleton" />
          <div className="h-10 w-32 animate-pulse rounded-md bg-skeleton" />
        </div>
      </div>
      <div className="mt-9 h-48 w-full animate-pulse rounded-md bg-skeleton" />
      <div className="mt-9 h-96 w-full animate-pulse rounded-md bg-skeleton" />
    </div>
  )
}
